import BaseModelAPI from '../BaseModelAPI';

export default class ScannerErrorLogList extends BaseModelAPI {

	static entity = 'scannererrorloglist'
	static entityName = 'scannererrorlog';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
